export class DynamicPageSlugNames {
    public static SHOP_HEADER = 'header';
    public static JOIN_HEADER = 'join-header';
    public static ABOUT_HEADER = 'about-header';
}
